export default __webpack_public_path__ + "static/media/skull red rose.8dca2d2d.png";